import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { ComponentStore, provideComponentStore } from '@ngrx/component-store';
import { immerReducer } from 'ngrx-immer/shared';

/**
 * Immer wrapper around `ImmerComponentStore` to mutate state
 * with `updater` and `setState`
 */
class ImmerComponentStore extends ComponentStore {
    updater(updaterFn) {
        return super.updater(immerReducer(updaterFn));
    }
    setState(stateOrUpdaterFn) {
        super.setState(stateOrUpdaterFn);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.7", ngImport: i0, type: ImmerComponentStore, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.1.7", ngImport: i0, type: ImmerComponentStore });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.7", ngImport: i0, type: ImmerComponentStore, decorators: [{
            type: Injectable
        }] });

/**
 * @description
 * Immer wrapper around `provideComponentStore()` in `@ngrx/component-store`.
 * @returns the ImmerComponentStore class registered as a provider
 */
function provideImmerComponentStore(componentStoreClass) {
    return provideComponentStore(componentStoreClass);
}

/**
 * Generated bundle index. Do not edit.
 */

export { ImmerComponentStore, provideImmerComponentStore };
